import { render, staticRenderFns } from "./DetailedSelect.global.vue?vue&type=template&id=49bbf348&"
import script from "./DetailedSelect.global.vue?vue&type=script&lang=js&"
export * from "./DetailedSelect.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports